// JS dibuja un calendario dentro del pop de calendario y ajusta la seleccion de dias segun un horario

js_calendar()
function js_calendar(){
    document.addEventListener('DOMContentLoaded', initCalendar)
}

function initCalendar() {
    const buttons = document.querySelectorAll('.js-calendar__buttons')
    const texts = document.querySelectorAll('.js-calendar__text')
    const values = document.querySelectorAll('.js-calendar__value')
    let no_date = 0

    const d = new Date();
    
    init()

    function createCalendar(){
        checkdate()
        
        if (d.getHours() > 19) {
            $('.datepicker').pickadate({
                labelMonthNext: 'Next month',
                labelMonthPrev: 'Previous month',
                today: '',
                clear: '',
                close: '',
                weekdaysShort: ['D', 'L', 'M', 'M', 'j', 'V', 'S'],
                monthsFull: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                disable: [
                    1,
                    [d.getFullYear(),d.getMonth(),no_date],
                    { from: -100, to: true },
                    // [2020, 5, 9, 'inverted'],
                ],
            })
        }else{
            $('.datepicker').pickadate({
                labelMonthNext: 'Next month',
                labelMonthPrev: 'Previous month',
                today: '',
                clear: '',
                close: '',
                weekdaysShort: ['D', 'L', 'M', 'M', 'j', 'V', 'S'],
                monthsFull: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                disable: [
                    1,
                    // { from: -100, to: [d.getFullYear(),d.getMonth(),date_self] },
                    { from: -100, to: true },
                    // [2020, 5, 9, 'inverted'],
                ],
            })
        }
    } 

    function init(){
        createCalendar()
        buttonsActions()
    }

    function buttonsActions() {
        if (buttons != null) {
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    const value = document.querySelector('.picker__input').value

                    textValue(value)
                    inputValue(value)
                })
            })
        }
    }

    function textValue(value) {
        if (texts != null) {
            texts.forEach(text => {
                text.innerHTML = value
            })
        }
    }

    function inputValue(val) {
        if (values != null) {
            values.forEach(value => {
                value.value = val
            })
        }
    }

    // check mes
    function checkdate(){
        const date = d.getDate()
        const month = d.getMonth()

        if (month == 10 || month == 3 || month == 5 || month == 8 || month == 10) {
            if (date == 30) {
                no_date = 1
            }else{
                no_date = date + 1
            }
        }

        if (month == 11 || month == 0 || month == 2 || month == 4 || month == 6 || month == 7 || month == 9) {
            if (date == 31) {
                no_date = 1
            }else{
                no_date = date + 1
            }
        }

        if (month == 1) {
            if (date == 28) {
                no_date = 1
            }else{
                no_date = date + 1
            }
        }
    }
}
